export default function(a, b) {
  return a - b;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-contour/src/ascending.js
// module id = null
// module chunks = 